<template>
	<app-card :colClasses="colClasses">
		<v-card-title>
			<h3>Xóa database</h3>
		</v-card-title>
		<v-data-table
			v-model="selected"
			:headers="headers"
			:items="items"
			select-all
			item-key="name"
			class="elevation-1"
			:loading="loader"
			disable-initial-sort
		>
			<template v-slot:headers="props">
				<tr>
					<th>
						<v-checkbox
							:input-value="props.all"
							:indeterminate="props.indeterminate"
							primary
							hide-details
							@click.stop="toggleAll"
						></v-checkbox>
					</th>
					<th
						v-for="header in props.headers"
						:key="header.text"
						:class="[
							'column sortable',
							`text-xs-${header.align}`,
							pagination.descending ? 'desc' : 'asc',
							header.value === pagination.sortBy ? 'active' : ''
						]"
						@click="changeSort(header.value)"
					>
						<v-icon small>arrow_upward</v-icon>
						{{ header.text }}
					</th>
				</tr>
			</template>
			<template v-slot:items="props">
				<tr
					:active="props.selected"
					@click="props.selected = !props.selected"
				>
					<td>
						<v-checkbox
							:input-value="props.selected"
							primary
							hide-details
						></v-checkbox>
					</td>
					<td class="text-xs-left">{{ props.item.name }}</td>
				</tr>
			</template>
		</v-data-table>
		<v-btn
			@click="clearCollection"
			:loading="loader"
			color="primary"
			block
		>
			Xóa Collection
		</v-btn>
	</app-card>
</template>

<script>
import api from "../../api";
export default {
	name: "clear-database",
	props: {
		colClasses: String,
		reload_collection: Boolean
	},
	data: () => ({
		pagination: {},
		selected: [],
		headers: [
			{
				text: "Collection",
				align: "left",
				value: "name"
			}
		],
		items: [],
		loader: false
	}),
	watch: {
		reload_collection: {
			handler: function (){
				this.getListCollection()
			},
			immediate: true
		}
	},
	methods: {
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.items.slice();
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		async getListCollection() {
			this.loader = true;
			this.items = [];
			const data = await api.getListCollections();
			this.items = data.data.data.map(col => ({
				name: col
			}));
			this.loader = false;
		},
		async clearCollection() {
			const list_collection_name = this.selected.map(col => col.name);
			if (!list_collection_name.length)
				return swal.fire(
					"Lỗi",
					"Vui lòng chọn collection cần xóa !!",
					"info"
				);
			const secret_key = window.prompt("Nhập mã bí mật ahihi: ");
			if (!secret_key) return;
			const db_name = window.prompt("Nhập tên db");
			if (!db_name) return;

			let that = this;
			swal.fire({
				title: "Xóa collections",
				text: `Bạn có chắc muốn xóa sổ ${list_collection_name.length} collections khỏi db ${db_name}"`,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#3085d6",
				confirmButtonText: "Xóa sạch!",
				cancelButtonText: "Trở về"
			}).then(async result => {
				if (result.value) {
					that.loader = true;
					let data = await api.clearCollections({
						secret_password: secret_key,
						db_name,
						list_collection_name
					});
					that.loader = false;
					if (data.status == 200) {
						swal.fire("Thành công", data.data.message, "success");
						that.getListCollection();
					} else {
						swal.fire("Lỗi", data.message, "error");
					}
				}
			});
		}
	}
};
</script>
<style>
</style>